import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
//import BootstrapVue3 from 'bootstrap-vue-3'
//import 'bootstrap'

//import "bootstrap/dist/css/bootstrap.min.css"
//import "bootstrap/dist/js/bootstrap.bundle.min.js"

// ストアの追加
import store from './store/store.js';
//import { storeAccessor } from './store/storeAccessor';

import { Buffer } from 'buffer';
window.Buffer = Buffer;

const app = createApp(App);
app.use(router, store);

import loadingOverlay from './preload/vue-loading-overlay';
loadingOverlay(app);

import fontawesome from './preload/fontawesome'
fontawesome(app);

import { init as axiosInit } from './preload/axiosBase';
axiosInit(app);

import { i18n } from './preload/i18n';
app.use(i18n);

import veeValidate from './preload/vee-validate';
veeValidate(app, i18n);

import ctkDateTimePicker from './preload/vue-ctk-date-time-picker';
ctkDateTimePicker(app);

import tooltip from './preload/tooltip';
app.directive("tooltip", tooltip);

import VueGoodTablePlugin from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css'
app.use(VueGoodTablePlugin);

//Google Analytics
import VueGtag from 'vue-gtag'
import { VueCookieNext } from 'vue-cookie-next';
app.use(VueCookieNext);
app.use(VueGtag, {
  config: {
    id: 'G-E0K2M1GFYX'
  }
  ,router
  ,enabled: false,
});
app.provide('gtag', app.config.globalProperties.$gtag);

/**
 * タイトルを表示
 */
const DEFAULT_TITLE = 'YubiOn SecureFileTransfer';
router.afterEach((to) => {
  document.title = to.meta.title || DEFAULT_TITLE;
});

app.mount('#app')
